<template>
    <Base>
      <template v-slot:basecontent>
        <div class="m-auto">
            <div class="rounded py-[12px] px-[24px] w-full bg-theme-grey">
              <!-- <div class="mb-4">
                <a @click.prevent="logout()" class="text-theme-green hover:text-white text-sm float-right" href="#">LOGOUT</a>
              </div> -->
              <div class="flex justify-between py-3">
                <p class="font-normal text-base text-[#9E9E9E]">{{currentDate()}}</p>
                <p class="font-normal text-base text-[#9E9E9E]">{{timestamp()}}</p>
              </div>
              <div class="hello mb-5 text-center text-white text-lg">Select which business you would like to access or create a new one!</div>
                <block-loading  v-if="loading" />
                <template v-else>
                  <div class="relative w-full mx-auto mt-4 mb-8">
                    <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                      <svg aria-hidden="true" class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                    </div>
                    <input v-model="searchtext" type="search" id="product-search" class="block p-2 pl-10 w-full bg-[#464851] text-white rounded-md focus:outline-none" placeholder="Search businesses">
                  </div>

                <div class="overflow-y-auto select-business-block overflow-hidden">
                  <div class="grid gap-4 lg:grid-cols-5 xl:grid-cols-6  sm:grid-cols-3 grid-cols-1">
                    <div v-if="vg_loggedInUser.userType == 'super'" @click.prevent="addBusiness()" class="bg-[#464851] hover:bg-theme-darkgreen mb-4 mx-2 py-4 px-2 text-center text-white cursor-pointer select-none rounded-lg w-[200px]">
                      <div class="text-9xl text-[#878686] mb-2" style="line-height: 0.7">+</div>
                      <span class="uppercase">New Business</span>
                    </div>

                    <template v-if="filteredBusinesses.length>0">
                      <div v-for="business in filteredBusinesses"  :key="business.id" @click="selectBusiness(business)" :class="selectedBusiness.id==business.id?'bg-theme-darkgreen':''"  class="bg-[#464851] mx-2 mb-4 py-4 px-6 hover:bg-theme-darkgreen text-center text-white cursor-pointer select-none rounded-lg w-[200px]">
                        <div>

                          <figure class="h-[90px] overflow-hidden bg-theme-grey-light w-full">
                            <img v-if="business.branding && business.branding.logo" :src="business.branding.logo" alt="" class="object-contain text-center h-full mx-auto">
                          </figure>
                  
                          <span class="text-sm">{{business.name}}</span>
                        </div>
                        
                        <div class="business-activity mt-5" @click.prevent="showToggleBusinessModal(business)">
                          <div class="flex flex-col justify-between">
                            <label class="flex items-center cursor-pointer">
                              <input type="checkbox" v-model="business.status" class="hidden peer">
                              <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (business.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                              <span class="ml-2 text-white text-sm font-medium uppercase" :class="business.status ? 'text-theme-green' : 'text-[#F53333]'">{{business.status ? 'On' : 'Off'}}</span>
                            </label>
                          </div>
                        </div>

                      </div>
                    </template>
                    <div v-else class="content-center text-white">
                      No business found
                    </div>
                  </div>
                </div>
             </template>
             <div  class="flex justify-center py-6">
              <button @click="confirmBusiness()" :disabled="!selectedBusiness || !selectedBusiness.id" class="disabled:bg-theme-modalbg flex justify-center items-center hover:opacity-70 w-[323px] h-[44px] px-4 py-2 rounded bg-[#2BA66B] font-bold text-base text-white leading-5 tracking-[0.15px]">CONFIRM</button>
             </div>

          </div>
        </div>
         <ToggleBusinessStatusModal :callback="closeToggleBusinessModal" :business="toggleBusinessStatus.business" v-if="toggleBusinessStatus.modal"/>
      </template>
    </Base>
</template>

<script lang="ts">
import { useRoute, useRouter } from 'vue-router'
import Helpers from '@/helpers';
import { ref, defineComponent } from "vue";
import Base from "@/views/Login/Base.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useStore } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import moment from 'moment';
import ToggleBusinessStatusModal from "@/views/Business/ToggleBusinessStatusModal.vue";
import SelectLocation from '@/views/Business/SelectLocation.vue'

export default defineComponent({
  name: 'SelectBusiness',
 
  components: {
    Base,
    ToggleBusinessStatusModal,
    SelectLocation,
  },

 setup() {
    const router = useRouter()
    const route = useRoute()
    const toggleBusinessStatus = ref({
      modal: false,
      business: {}
    });
    const store = useStore()
    const loading = ref<Boolean>(false);
    var filteredBusinesses = ref<[]>([]);
    const searchtext = <any>ref('');
    const snackbar = useSnackbar();
    const selectedBusiness = <any>ref({})

    return {
      router,
      route,
      filteredBusinesses,
      loading,
      searchtext,
      store,
      snackbar,
      toggleBusinessStatus,
      selectedBusiness
    };


 },
  
  async mounted() {
    
    this.loading = true;
    await this.va_setUserBusinesses();
    // skip if only one business
    if(this.vg_userBusinesses.length==1){
      this.selectedBusiness = this.vg_userBusinesses[0]
      this.confirmBusiness()
    }
    this.loading = false
    this.filteredBusinesses = this.store.getters['auth/businesses'];
  },
  
  computed: {
    ...mapGetters({
      vg_loggedInUser: 'auth/user',
      vg_userBusinesses: 'auth/businesses',
    }),
  },
  watch: {
    'searchtext'(value) {
      this.filteredBusinesses = value ? this.store.getters['auth/businesses'].filter((item) => item.name.toLowerCase().includes(value.toLowerCase() ) ) : this.store.getters['auth/businesses'];
    },
    'vg_userBusinesses'(val) {
      this.filteredBusinesses = this.searchtext ? this.store.getters['auth/businesses'].filter((item) => item.name.toLowerCase().includes(this.searchtext.toLowerCase()) ) : val;
    },
    
  },
  

  methods: {
     
    currentDate() {
      const current = moment(new Date()).format("dddd, MMMM Do");
      return current;
    },
    timestamp (){
      const today = moment().format('h:mm A');
        return today;
    },
   
   
    /**
     * Show Toggle modal
     */
    showToggleBusinessModal(business) {
      this.toggleBusinessStatus = {
        modal: true,
        business: business
      };
    },

    /**
     * Close Toggle modal
     */
    closeToggleBusinessModal() {
      this.toggleBusinessStatus = {
        modal: false,
        business: {}
      };
    },

    selectBusiness(business){
      this.selectedBusiness = business
    },

    /**
     * Confirm business
     */
    async confirmBusiness() {
      let selectedBusiness = <any>this.selectedBusiness
      if(selectedBusiness.id){
        // as son as business selected get refresh token 
        this.va_spinner(true);
        let res = await this.va_setUserActiveBusiness(this.selectedBusiness);
        this.va_spinner(false);
        if(res.status == 200) {
          this.router.push({
            name: 'SelectLocation'
          })
        } else if(res.response && res.response.status == 401) {
          this.router.push({
            name: 'Login'
          })
          this.va_clearUserData();
        }

        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
      }

    },

    addBusiness(){
      // only super user can see and add business
      if(this.vg_loggedInUser.userType == 'super') {
        this.router.push({
          name: 'AddBusiness'
        })
      }
    },

    /**
     * Logout
     */

    logout() {
      this.store.dispatch('auth/clearUserData')
      this.router.push({
        name: 'Login'
      })
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_setUserBusinesses: "auth/setUserBusinesses",
      va_clearUserData: "auth/clearUserData",
      va_setUserActiveBusiness: "auth/setUserActiveBusiness",
    })
  }

});

</script>

<style scoped>
.select-business-block {
  max-height: 35vh;
}

</style>